export default __webpack_public_path__ + "media/color/pax-871d75ab.svg";